import { Alpine as IAlpine } from 'alpinejs';
import DsCookies from './DsCookies';
import InfoBox from './InfoBox';

export default function (Alpine: IAlpine) {
  const cookies = new DsCookies();

  Alpine.magic('cookies', () => cookies);
  Alpine.data('CookiesInfoBox', InfoBox);
  
  if (typeof window !== 'undefined') {
    (window as any).DsCookies = cookies;
  }
}
